import {
    getPropertyBankVerifyLists,
    updatePropertyBankVerify,
    getPropertyBankVerifyMessages,
    createPropertyBankVerifyMessage,
    getAllPropertyVerifyLists
} from '../../../services/PropertyBankVerificationService';
import {
    CONFIRMED_GET_PROERTY_BANK_VERIFY_LISTS,
    CONFIRMED_GET_PROERTY_BANK_VERIFY_MESSAGES
} from './PropertyBankVerificationTypes';

export function getPropertyBankVerifyListsAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_BANK_VERIFICATION_LOADING', payload: true });
        getPropertyBankVerifyLists(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetPropertyBankVerifyListsAction(response.data.data));
            })
            .catch(() => {
                dispatch(confirmedGetPropertyBankVerifyListsAction({ rows: [], count: 0, pages: 1 }));
            })
            .finally(() => {
                dispatch({ type: 'SET_BANK_VERIFICATION_LOADING', payload: false });
            });
    };
}

export function getAllPropertyVerifyListsAction(filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_BANK_VERIFICATION_LOADING', payload: true });
        getAllPropertyVerifyLists(filterQuery).then((response) => {
            dispatch(confirmedGetPropertyBankVerifyListsAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_BANK_VERIFICATION_LOADING', payload: false });
        });
    };
}

export function confirmedGetPropertyBankVerifyListsAction(data) {
    return {
        type: CONFIRMED_GET_PROERTY_BANK_VERIFY_LISTS,
        payload: data,
    };
}

export function updatePropertyBankVerifyAction(id, data) {
    return () => {
        return updatePropertyBankVerify(id, data).then((response) => {
            return response;
        });
    };
}

export function getPropertyBankVerifyMessagessAction(filterQuery, refreshList = true) {
    
    return (dispatch, getState) => {
        if(refreshList)
            dispatch(confirmedGetPropertyBankVerifyMessagesAction([]));
        getPropertyBankVerifyMessages(filterQuery).then((response) => {
            dispatch(confirmedGetPropertyBankVerifyMessagesAction(response.data.data));
        });
    };
}

export function confirmedGetPropertyBankVerifyMessagesAction(data) {
    return {
        type: CONFIRMED_GET_PROERTY_BANK_VERIFY_MESSAGES,
        payload: data,
    };
}

export function createPropertyBankVerifyMessageAction(data) {
    return () => {
        return createPropertyBankVerifyMessage(data).then((response) => {
            return response;
        });
    };
}



